import { translationKey } from '@change-corgi/core/i18n';
import { iconVictory } from '@change-corgi/design-system-legacy/icons';

import { usePetitionSettingsPageData } from '#src/app/pages/petitionEditV2/pageContext';

export const useSettings = () => {
	const settingsData = usePetitionSettingsPageData();
	const {
		petition: { status },
	} = settingsData.data;

	const { statusLabel, statusColor, statusIcon } = (() => {
		if (status === 'CLOSED') {
			return {
				statusLabel: translationKey('corgi.petition.edit.settings.status.closed'),
				statusColor: 'text-typography-error',
				statusIcon: null,
			};
		}

		if (status === 'VICTORY') {
			return {
				statusLabel: translationKey('corgi.petition.edit.settings.status.victory'),
				statusColor: 'primary-changeRed',
				statusIcon: iconVictory,
			};
		}

		return {
			statusLabel: translationKey('corgi.petition.edit.settings.status.active'),
			statusColor: 'text-typography-success',
			statusIcon: null,
		};
	})();

	return {
		data: {
			petitionStatus: status,
			statusLabel,
			statusColor,
			statusIcon,
		},
	};
};
